import Link from "next/link";

import styled from "styled-components";

import { Typo } from "@enkor/design/components";
import { grayScale } from "@enkor/design/colors";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;

  width: 100%;
  margin-bottom: 16px;
  padding: 16px 0;

  background-color: ${grayScale[200]};
`;

export const AvgIndicator = styled.div`
  display: inline-flex;
  align-items: center;

  padding: 0 16px;
`;

export const AvgText = styled(Typo.Heading)`
  margin-left: 8px;
`;

export const UnderlineLink = styled(Link)`
  width: calc(100% - 32px);
  margin: auto;
  padding: 13px 16px;
  border: 1px solid ${grayScale.white};
  border-radius: 8px;

  color: ${grayScale.white};
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
`;

export const ReviewCardListWrapper = styled.div`
  position: relative;
  overflow: hidden;

  width: 100%;
  height: auto;
`;
